export const gh = (v?: string | null) =>
  v == null || v === "" ? "Contact" : `GH₵${Number(v)}`;


export const formatLimitText = (label: string, val: string | null) =>
  val === null ? `Unlimited ${label}` : `Add up to ${val} ${label}`;


export const percentSaved = (monthly: string | null, yearly: string | null) => {
  if (!monthly || !yearly) return null;
  const yearlyEquivalent = Number(monthly) * 12;
  if (yearlyEquivalent <= 0) return null;
  const savings = 1 - Number(yearly) / yearlyEquivalent;
  return savings > 0 ? Math.round(savings * 100) : 0;
};